'use client';

import { useBlockPart, type MediaEpisode } from '@akademi/site-builder-runtime';
import { EpisodeCard } from './EpisodeCard';

/**
 * In-series watch sidebar — list of episodes with active highlight.
 */
export interface SeriesPlaylistSidebarProps {
  episodes: MediaEpisode[];
  activeEpisodeSlug?: string;
  seriesSlug: string;
  episodeHrefTemplate?: string;
}

export function SeriesPlaylistSidebar({
  episodes,
  activeEpisodeSlug,
  seriesSlug,
  episodeHrefTemplate,
}: SeriesPlaylistSidebarProps) {
  const part = useBlockPart();
  return (
    <aside
      {...part('list')}
      style={{
        background: 'var(--color-surface-card, #fff)',
        border: '1px solid var(--color-border, rgba(0,0,0,0.08))',
        borderRadius: 8,
        padding: 8,
        maxHeight: '80vh',
        overflowY: 'auto',
      }}
    >
      {episodes.map((e) => (
        <EpisodeCard
          key={e.id}
          episode={e}
          style="rail"
          active={activeEpisodeSlug === e.slug}
          seriesSlug={seriesSlug}
          {...(episodeHrefTemplate ? { hrefTemplate: episodeHrefTemplate } : {})}
        />
      ))}
    </aside>
  );
}
